"use strict";
import React, { forwardRef } from "react";
import { TransitionGroup, Transition } from "react-transition-group";
import Button, { ButtonType } from "../Button/Button";
import Tooltip from "../Tooltip/Tooltip";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
import * as styles from "./IconButton-css";
const IconButton = forwardRef(
  ({ type, icon, disabled, tooltip, disabledReason, "aria-label": ariaLabel, size, ...buttonProps }, ref) => {
    const tooltipContent = disabled && !!disabledReason ? disabledReason : tooltip?.content;
    const tooltipBasedLabel = tooltip?.show ? void 0 : tooltip?.content.toString();
    const renderButton = () => /* @__PURE__ */ React.createElement(
      Button,
      {
        isIconOnly: true,
        disabled,
        type,
        ref,
        size,
        "aria-label": ariaLabel || tooltipBasedLabel,
        ...buttonProps
      },
      /* @__PURE__ */ React.createElement(TransitionGroup, { component: null }, /* @__PURE__ */ React.createElement(Transition, { onEnter: forceReflow, key: icon.key ?? void 0, timeout: AnimationDuration.Medium }, (status) => /* @__PURE__ */ React.createElement("div", { className: styles.iconWrapper({ status }) }, icon)))
    );
    if (tooltip) {
      return (
        /**
         * @NOTE(mbusby, 2020-10-07):
         * We apply wrapTarget when the button is disabled, as not all browsers
         * support mouse events on disabled buttons, which are required
         * for the `Tooltip` to work correctly.
         */
        /* @__PURE__ */ React.createElement(Tooltip, { wrapTarget: disabled, ...tooltip, content: tooltipContent ?? "" }, renderButton())
      );
    }
    return renderButton();
  }
);
IconButton.defaultProps = {
  type: ButtonType.Tertiary
};
export default IconButton;
